module.exports = __webpack_public_path__ + "img/d2tsl.a54eceae.png";